import { BaseDto } from "@/shared/dtos/base-dto";

export class manychat_mensajes_log extends BaseDto {
  public id_solicitud: number | null = null;
  public tipo_mensaje: string = "";
  public telefono: string = "";
  public mensaje_texto: string = "";
  public estado_envio: string = "";
  public manychat_response: string = "";
  public created_at: Date | null = null;

  constructor(data?: any) {
    super();
    if (!data) return;
    this.copy(data);
    if (data.created_at) this.created_at = new Date(data.created_at);
  }
}
